import { Box, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import {
  AsIsValue,
  PropertyAddress,
  PurchasePrice,
} from '../../propertyInformation/components/propertyInformationFields';
import { PropertyFormStore } from '../../../stores/properties/propertyFormStore';
import { RoundedBackgroundIcon } from '../../../components/roundedBackgroundIcon';
import { HomeWorkOutlined } from '@material-ui/icons';
import { ItemDisplay } from '../../../components/itemDisplay';
import { FORM_MAX_WIDTH } from '../../../utils/constants';
import { QuoteTypeStore } from '../../../stores/quoteTypeStore';

export const RentalPortfolioPreflightPropertyForm = observer(
  ({
    store,
    propertyFormStore,
  }: {
    store: QuoteTypeStore;
    propertyFormStore: PropertyFormStore;
  }) => {
    const property = propertyFormStore.getFormValues();
    return (
      <Box maxWidth={FORM_MAX_WIDTH} marginLeft="auto" marginRight="auto">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid
                item
                container
                spacing={2}
                xs={8}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item alignItems="center" style={{ height: '100%' }}>
                  <RoundedBackgroundIcon
                    Icon={HomeWorkOutlined}
                    iconColor="#6D6D6D"
                  />
                </Grid>
                <Grid item>
                  <ItemDisplay
                    label="Property Type"
                    value={property.propertyType}
                    alignItems="flex-start"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "1rem" }}>
            <PropertyAddress store={propertyFormStore} quoteTypeStore={store} />
          </Grid>

          <Grid item xs={12} sm={6}>
            <PurchasePrice store={propertyFormStore} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AsIsValue store={propertyFormStore} />
          </Grid>

        </Grid>
      </Box>
    );
  }
);
